import React = require('react');
import { IChannel, IPremium, IProduct, ITraveller } from '../../../../../../data/api/models';
import { forEach, get } from 'lodash';
import { renderDirectoryDetails } from '../../../Signpost/Components/MedicalSignpost/DirectoryDetails';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isNotFalse, isRequired } from '../../../../../../util/validators';
import { EditSectionButton } from '../QuoteSummary/components/EditSectionButton';
import MedicalImportantSection from '../MedicalImportantSection';

interface IMedicalLoadProps {
  travellers: ITraveller[];
  product: IProduct;
  isSignposted: boolean;
  isCalculating: boolean;
  channel: IChannel;
  handleEdit?: (key?: string) => any;
  premium: IPremium;
  isAggregator?: boolean;
  isQuoteSubmitted?: boolean;
}

export const MedicalDetails = ({
                                 travellers,
                                 isSignposted,
                                 isCalculating,
                                 channel,
                                 handleEdit,
                                 premium,
                                 isAggregator,
                                 isQuoteSubmitted,
                                 ...props
                               }: IMedicalLoadProps) => {

  let medicalConditions = 0;
  const isAggregatorChannel = get(channel, 'channelType', '') === 'AGG';
  forEach(travellers, (traveller, key) => {
    medicalConditions += get(traveller, 'screening.meta.conditions', []).length
  })

  const renderConfirmCheckbox = () => {
    return (
      <div>
        <div>
          <Field
            name={'signpost_consent'}
            type="checkbox"
            value="true"
            component={FieldFormControl}
            validate={[isRequired, isNotFalse]}
          >
            <div/>
            <strong>I have read and understand the information above.</strong>
          </Field>
        </div>
      </div>
    );
  }

  const editMedical = () => {
    handleEdit('medicalHistory')
  }

  return (
    <div>
      <div className={'medical-load-card'}>
        <div className={'medical-load-header'}>
          {!medicalConditions && (
            <>
              <div className={'medical-load-header-container'}>
                <div className={'medical-load-title'}>No medical conditions declared</div>
                <EditSectionButton isCalculating={isCalculating} handleEdit={editMedical}
                                   hidden={isAggregatorChannel}/>
              </div>
              <MedicalImportantSection hasTravellerDeclaredCondition={false} premium={premium}
                                       isAggregator={isAggregator} isQuoteSubmitted={isQuoteSubmitted} {...props}/>
            </>
          )}
          {medicalConditions > 0 && (
            <>
              <div className={'medical-load-header-container'}>
                <div className={'medical-load-title'}>You've declared {medicalConditions} medical condition</div>
                <EditSectionButton isCalculating={isCalculating} handleEdit={editMedical}
                                   hidden={isAggregatorChannel}/>
              </div>
              <MedicalImportantSection hasTravellerDeclaredCondition={true} premium={premium}
                                       isAggregator={isAggregator} isQuoteSubmitted={isQuoteSubmitted} {...props}/>
            </>
          )}
        </div>
        {isSignposted && (
          <div className={'medical-load-body'}>
            <div style={{ marginBottom: '15px' }}>
              <strong>You may be able to get cover through a specialist provider</strong>
            </div>
            <div>
              Your quote includes an additional premium due to the medical information provided.
              You may find cheaper or more suitable cover using the MoneyHelper travel insurance directory. This has
              been created for anyone who may have received a high additional premium due to their medical conditions,
              to allow them to shop around for alternative providers.
            </div>
            <div>{renderDirectoryDetails(false)}</div>
            <div>
              <strong>Please note:</strong> If you’re insuring multiple travellers on separate policies, you may not be
              covered for claims related to the pre-existing medical conditions of someone not named on your policy.
            </div>
            <div className={'check-box'}>
              {renderConfirmCheckbox()}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
